import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { EndUserFormMessageConfiguration, StyledCheckboxInput } from "../../../../common/form";
import { connect } from "react-redux";
import {
    PERSONAL_DATA_FORM_MESSAGE_VALIDATION_RULES,
    PERSONAL_DATA_FORM_POPUP_VALIDATION_RULES,
} from "./PersonalDataFormValidationRules";
import PersonalDataPreviewForm from "./PersonalDataPreviewForm";
import { Modal } from "react-bootstrap";
import { EN } from "../../../../common/enums/languages";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINTECH } from "../../../../../utils/Roles";
import { TERMINATED } from "../../enums/clientStatusTypes";

const extractLocalization = (localizations, localizedFieldName) => {
    const extractedLocalization = Object.keys(localizations).reduce((acc, lang) => {
        return {
            ...acc,
            [lang]: {
                [localizedFieldName]: localizations[lang][localizedFieldName],
            },
        };
    }, {});

    return {
        localizations: extractedLocalization,
    };
};

class PersonalDataConfigurationFields extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showPreviewModal: false,
            formHref: "",
            disableInfoTitleBtn: false,
        };

        this.handleModal = this.handleModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { clientDesignator, infoTitleLocal } = this.props;
        if (clientDesignator && !this.state.formHref) {
            let endpoint = "/donnees";
            const userLanguage = localStorage.getItem("languageCode") || EN.value;

            if (userLanguage == EN.value) {
                endpoint = "/data";
            }

            this.setState({ formHref: `${endpoint}/${clientDesignator}` });
        }

        if (prevProps.infoTitleLocal !== infoTitleLocal) {
            const enLocal = infoTitleLocal["en-CA"].infoTitle;
            const frLocal = infoTitleLocal["fr-CA"].infoTitle;

            if (
                enLocal.length > PERSONAL_DATA_FORM_POPUP_VALIDATION_RULES.infoTitle.maxLength.value ||
                frLocal.length > PERSONAL_DATA_FORM_POPUP_VALIDATION_RULES.infoTitle.maxLength.value
            ) {
                this.setState({ disableInfoTitleBtn: true });
            } else {
                this.setState({ disableInfoTitleBtn: false });
            }
        }
    }

    renderPreviewModal() {
        return (
            <Modal show={this.state.showPreviewModal}>
                <div className="modal-main white-modal preview-personal-data-modal">
                    <Modal.Header>
                        <span className="close" onClick={() => this.handleModal(false)} />
                    </Modal.Header>
                    <Modal.Body>
                        <PersonalDataPreviewForm />
                    </Modal.Body>
                </div>
            </Modal>
        );
    }

    handleModal(isOpen) {
        if (this.state.showPreviewModal !== isOpen) {
            this.setState({ showPreviewModal: isOpen });
        }
    }

    handleSubmit(e) {
        e.preventDefault();
    }

    render() {
        const { onChange, updateMessageConfiguration, onClientFieldChange, clientStatusType} = this.props;
        const {
            localizations,
            hasPersonalDataForm,
            hasPersonalDataFormMessage,
            hasPersonalDataPopupMessage,
        } = this.props.initialValues;

        const disableForm = !userHasAccess(FINTECH) && clientStatusType === TERMINATED.value;
        return (
            <div>
                <form onSubmit={this.handleSubmit} className="withdrawal-configuration configuration-form">
                    <fieldset disabled={disableForm}>
                    <h3>
                        <FormattedMessage id="clients.client.personalDataConfig.title" />
                    </h3>
                    <Field
                        id="hasPersonalDataForm"
                        name="hasPersonalDataForm"
                        component={StyledCheckboxInput}
                        groupClassName="inverted-label"
                        type="checkbox"
                        checkbox={{ value: true }}
                        props={{ onChange: onClientFieldChange }}
                        label={<FormattedHTMLMessage id="clients.client.personalDataConfig.form.createForm" />}
                        normalize={(value) => !!value}
                    />

                    {hasPersonalDataForm && (
                        <div>
                            <hr />

                            <Field
                                id="hasPersonalDataFormMessage"
                                name="hasPersonalDataFormMessage"
                                component={StyledCheckboxInput}
                                type="checkbox"
                                checkbox={{ value: true }}
                                props={{ onChange: onClientFieldChange }}
                                label={
                                    <FormattedMessage id="clients.client.personalDataConfig.form.hasPersonalDataFormMessage" />
                                }
                                normalize={(value) => !!value}
                            />

                            {hasPersonalDataFormMessage && localizations && (
                                <EndUserFormMessageConfiguration
                                    form="configMessage"
                                    initialValues={extractLocalization(localizations, "configMessage")}
                                    localizedFieldName="configMessage"
                                    fieldType="textarea"
                                    onSubmit={updateMessageConfiguration}
                                    validationRules={PERSONAL_DATA_FORM_MESSAGE_VALIDATION_RULES}
                                />
                            )}

                            <Field
                                id="hasPersonalDataPopupMessage"
                                name="hasPersonalDataPopupMessage"
                                component={StyledCheckboxInput}
                                type="checkbox"
                                checkbox={{ value: true }}
                                props={{ onChange: onClientFieldChange }}
                                label={<FormattedMessage id="clients.client.personalDataConfig.form.hasPersonalDataPopupMessage" />}
                                normalize={(value) => !!value}
                            />
                            {hasPersonalDataPopupMessage && localizations && (
                                <div>
                                    <EndUserFormMessageConfiguration
                                        formTitle={
                                            <h5>
                                                <FormattedMessage id="withdrawalConfiguration.form.withdrawalPopupTitle" />
                                            </h5>
                                        }
                                        form="personalDataFormInfoTitleConfig"
                                        initialValues={extractLocalization(localizations, "infoTitle")}
                                        localizedFieldName="infoTitle"
                                        onSubmit={updateMessageConfiguration}
                                        validationRules={PERSONAL_DATA_FORM_POPUP_VALIDATION_RULES}
                                        disableBtn={this.state.disableInfoTitleBtn}
                                    />
                                    <EndUserFormMessageConfiguration
                                        formTitle={
                                            <h5>
                                                <FormattedMessage id="withdrawalConfiguration.form.withdrawalPopupMessage" />
                                            </h5>
                                        }
                                        fieldType="textarea"
                                        form="personalDataFormInfoMessageConfig"
                                        initialValues={extractLocalization(localizations, "infoMessage")}
                                        localizedFieldName="infoMessage"
                                        onSubmit={updateMessageConfiguration}
                                        validationRules={PERSONAL_DATA_FORM_POPUP_VALIDATION_RULES}
                                    />
                                </div>
                            )}
                            <hr />
                            <div className="personal-data-section">
                                <h4 className="personal-data-title client-form-mb">
                                    <FormattedMessage id="clients.client.personalDataConfig.personalData" />
                                </h4>
                                <p className="client-form-mb">
                                    <FormattedMessage id="clients.client.personalDataConfig.subTitle" />
                                </p>
                                <div className="flex-personal-form">
                                    <div className="personal-data-checkbox-section">
                                        <Field
                                            id="firstName"
                                            name="firstName"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.firstName" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="lastName"
                                            name="lastName"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.lastName" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.phoneNumber" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="birthdate"
                                            name="birthdate"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.birthDate" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="memberGenderType"
                                            name="memberGenderType"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.gender" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="languageCode"
                                            name="languageCode"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.language" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="emailAddress"
                                            name="emailAddress"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.email" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                    </div>

                                    <div className="personal-data-checkbox-section">
                                        <Field
                                            id="address"
                                            name="address"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.address" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="city"
                                            name="city"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.city" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="countryCode"
                                            name="countryCode"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.country" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="provinceCode"
                                            name="provinceCode"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.province" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                        <Field
                                            id="postalCode"
                                            name="postalCode"
                                            component={StyledCheckboxInput}
                                            type="checkbox"
                                            checkbox={{ value: true }}
                                            props={{ onChange }}
                                            label={
                                                <FormattedMessage id="clients.client.personalDataConfig.form.postalCode" />
                                            }
                                            normalize={(value) => !!value}
                                        />
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <div className="flex-personal-form">
                                <button
                                    disabled={!hasPersonalDataForm}
                                    onClick={() => this.handleModal(true)}
                                    type="submit"
                                    className="btn btn-lg btn-primary gap"
                                >
                                    <FormattedMessage id="clients.client.personalDataConfig.form.formVisualization" />
                                </button>
                                <a className="btn btn-lg btn-primary gap" target="_blank" href={this.state.formHref}>
                                    <FormattedMessage id="clients.client.personalDataConfig.form.formAccess" />
                                </a>
                            </div>
                        </div>
                    )}
                    </fieldset>
                </form>
                {this.renderPreviewModal()}
            </div>
        );
    }
}

PersonalDataConfigurationFields.propTypes = {
    initialValues: PropTypes.object,
    clientDesignator: PropTypes.string,
    clientStatusType: PropTypes.string,
    infoTitleLocal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    updateMessageConfiguration: PropTypes.func,
    onClientFieldChange: PropTypes.func,
    onChange: PropTypes.func,
};

function mapStateToProps(state) {
    const selector = formValueSelector("personalDataConfiguration");
    const activeClient = state.data.clients.active;
    const infoTitleLocal = state.form.personalDataFormInfoTitleConfig
        ? state.form.personalDataFormInfoTitleConfig.values.localizations
        : null;

    return {
        hasWithdrawalForm: selector(state, "hasPersonalDataForm"),
        hasPersonalDataFormMessage: selector(state, "hasPersonalDataFormMessage"),
        hasPersonalDataPopupMessage: selector(state, "hasPersonalDataPopupMessage"),
        firstName: selector(state, "firstName"),
        clientDesignator: activeClient.designator,
        infoTitleLocal: infoTitleLocal,
    };
}

export default connect(mapStateToProps, null, null, { withRef: true })(
    reduxForm({
        form: "personalDataConfiguration",
    })(PersonalDataConfigurationFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/personal-data-configuration/PersonalDataConfigurationFields.js